import { render, staticRenderFns } from "./AccordionEventNavItemPopover.vue?vue&type=template&id=b5fad8f4"
import script from "./AccordionEventNavItemPopover.vue?vue&type=script&lang=js"
export * from "./AccordionEventNavItemPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports